import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { ColumnBox } from '../../styles/commonStyles';
import { CardLayout } from '../layouts/CardLayout';
import { theme } from '../../configs/theme';
import ThemeButton from './ThemeButton';
import { ThemeTypography } from './ThemeTypography';

type props = {
  children: ReactNode;
  title?: string;
  buttonText: string;
  buttonOnClick: any;
  buttonIsDisabled: boolean;
  width?: string;
  /** Shows a "Ta bort" button on the left. */
  onDelete?: () => void;
};

export default function PageForm({
  children,
  title,
  buttonText,
  buttonOnClick,
  buttonIsDisabled,
  width = '100%',
  onDelete,
}: props) {
  return (
    <>
      <ThemeTypography type="heading1" color={theme.palette.customColors.emerald}>
        {title}
      </ThemeTypography>
      <ColumnBox sx={{ width: width, gap: '1rem' }}>
        <CardLayout>{children}</CardLayout>
        <Box
          sx={{
            display: 'flex',
            flexFlow: 'row-reverse',
            padding: '0.5rem',
            position: 'sticky',
            bottom: 0,
            backgroundColor: theme.palette.customColors.cultured,
          }}
        >
          <ThemeButton onClick={buttonOnClick} isDisabled={buttonIsDisabled}>
            {buttonText}
          </ThemeButton>
          {onDelete && (
            <ThemeButton buttonType="error" onClick={onDelete} sx={{ marginRight: 'auto' }}>
              Ta bort
            </ThemeButton>
          )}
        </Box>
      </ColumnBox>
    </>
  );
}
